export default () => {
  document.addEventListener('turbolinks:load', () => {
    const checkAllBtn = document.querySelector('.js-check-all-button');
    const uncheckAllBtn = document.querySelector('.js-uncheck-all-button');
    const checkBoxes = document.querySelectorAll('.js-check-box');

    checkAllBtn.addEventListener('click', () => {
      Array.from(checkBoxes).forEach((checkBox) => {
        checkBox.checked = true;
      });
    });

    uncheckAllBtn.addEventListener('click', () => {
      Array.from(checkBoxes).forEach((checkBox) => {
        checkBox.checked = false;
      });
    });
  });
}
